import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.invoice_formula',
    component: Settings,
    path: '/modules/invoice_formula',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
